import { render, staticRenderFns } from "./GoogleExtendedTextAd.vue?vue&type=template&id=68b889a8&scoped=true&"
import script from "./GoogleExtendedTextAd.vue?vue&type=script&lang=js&"
export * from "./GoogleExtendedTextAd.vue?vue&type=script&lang=js&"
import style0 from "./GoogleExtendedTextAd.vue?vue&type=style&index=0&id=68b889a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b889a8",
  null
  
)

export default component.exports